/* © CNES */
import { Image } from 'primereact/image';
import Logos from '../../assets/images/logosToolbarLightGeodes.png';
import './PageNotFound.scss';

/**
 * PageNotFound Page displayed when url is not valid in application.
 * @returns Element.
 */
export const PageNotFound = () => {
  return (
    <div className="NotFoundContainer">
      <div className="HeaderContainer">
        <Image aria-label="Logos" src={Logos} alt="app_logos" width="360" />
      </div>

      <div className="IllustrationContainer">
        <img
          alt="Maintenance page illustration"
          src={require('../../assets/images/pageMaintenance.png')}
        />
      </div>

      <div className="TextContainer">
        <h1 className="TextTitle">EARTH NOT FOUND</h1>
        <h3 className="TextDescription">
          The page you are looking for does not exist !
        </h3>
      </div>
    </div>
  );
};
